export default {"src":"/_next/static/media/phone_solid_24.3e75b7d1.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};